module.exports = __webpack_public_path__ + "static/media/tj.3b8083ea.svg";